export enum CertificateStatus {
  VALID = 'Verified',
  INVALID = 'Invalid',
  REVOKED = 'Revoked'
}

export interface Student {
  id: string;
  name: string;
  email: string;
  enrolledCourses: number;
  completedCourses: number;
}

export interface Certificate {
  id: string;
  certificateId: string; // The verifiable code
  studentName: string;
  courseName: string;
  issueDate: string;
  status: CertificateStatus;
  description?: string; // AI generated description
  verifyUrl?: string;
  qrImageUrl?: string;
}

export interface DashboardStats {
  totalVerified: number;
  totalStudents: number;
  recentActivity: Certificate[];
}

export type UserRole = 'Admin' | 'SuperAdmin';

export interface UserProfile {
  name: string;
  role: UserRole;
  email: string;
  location?: string;
}
